import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { MedicalInfo } from './MedicalInfo';
import { history } from '../_helpers';
import { medicalInfoAction } from '../actions/medicalInfo.action';
import { Container } from 'react-bootstrap';

class SicknoteMedicalInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formType: 'sick-note' // default
    };

    // this.handleEdit = this.handleEdit.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;

    // Get formType from URL params
    const urlParams = new URLSearchParams(window.location.search);
    const formType = urlParams.get('formType') || 'sick-note';
    this.setState({ formType });

    dispatch(medicalInfoAction.getByPerson());
  }

  handleEdit = () => {
    const { formType } = this.state;
    history.push(`/medicalInfo/edit?formType=${formType}`);
  };

  handleConfirm() {
    const { dispatch } = this.props;

    // Get formType directly from URL to avoid state timing issues
    const urlParams = new URLSearchParams(window.location.search);
    const formType = urlParams.get('formType') || 'sick-note';

    // Navigate to sick-note route with proper formType parameter
    if (formType === 'school-work-form') {
      history.push('/sick-note?formType=school-work-form');
    } else {
      history.push('/sick-note');
    }
  }

  render() {
    const { formType } = this.state;
    const formTitle = formType === 'school-work-form' ? 'Request a Form' : 'Sick Note';

    return (
      <Container>
        <div className="sick-note-medical-info-container">
          <h1 className="h5 mb-3 font-weight-normal">First, please confirm your personal medical information for {formTitle}:</h1>
          <hr />
          <MedicalInfo />
          <hr className="mb-4" />
          <div className="mb-3 d-flex justify-content-between">
            <button className="btn btn-secondary btn-lg mr-3" onClick={this.handleEdit}>
              Add/Edit
            </button>
            {!this.props.noMedicalInfo && (
              <button className="btn btn-primary btn-lg btn-sign-up" onClick={this.handleConfirm} data-test-id="prescription-medical-info__confirm-button">
                Confirm
              </button>
            )}
          </div>
        </div>
      </Container>
    );
  }
}

SicknoteMedicalInfo.propTypes = {
  dispatch: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  const { noMedicalInfo } = state.medicalInfo;

  return {
    // status,
    noMedicalInfo
  };
}

const temp = connect(mapStateToProps)(SicknoteMedicalInfo);

export { temp as SicknoteMedicalInfo };
